import axios from 'axios';

/**
 * Quick-IOTのAPIを操作するサービスクラスの基底クラスです。
 */
class Service {
    /**
     * APIのエンドポイントです。
     */
    private readonly apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

    /**
     * エラーメッセージ一覧です。
     */
    protected readonly errorMessageList: { [key: string]: string } = {};

    constructor() {
        this.createErrorMessage();
    }

    /**
     * APIエンドポイントを生成します。
     * @param apiName API名を指定します。
     * @returns 生成したエンドポイントを返します。
     */
    protected createApiEndpoint(apiName: string) {
        const url = `${this.apiEndpoint}/${apiName}`;

        return url;
    }

    /**
     * セッションストレージに格納されているJWTを取得します。
     * @returns JWTを返します。存在しない場合はNULLが返ります。
     */
    protected getJwt() {
        const jwt = sessionStorage.getItem('jwt');

        if (jwt === null) {
            throw new Error('JWT is null');
        }

        return jwt;
    }

    /**
     * エラーメッセージの生成を行います。
     */
    private createErrorMessage() {
        this.errorMessageList['account_name already exists'] = '既に登録されているユーザー名です。';
        this.errorMessageList['email already exists'] = '既に登録されているメールアドレスです。';
        this.errorMessageList['user not found'] = 'ユーザーが存在しません。';
    }

    /**
     * APIに対してPOSTリクエストを行います。
     * @param url URLを指定します。
     * @param params POSTするパラメータを指定します。
     * @param body リクエストのボディを指定します。
     * @returns POST結果を返します。
     */
    protected async httpPost<T>(url: string, params: any, body: any | null = null) {
        const response = await axios.post<T>(url, body, {
            params: params
        }).catch((reson) => {
            if (reson.constructor.name === 'AxiosError') {
                const response = reson.response;
                if (response !== undefined && response.data !== undefined) {
                    const result = response.data;

                    if (response.status >= 500) {
                        const errorMessage = `HTTP Status: ${response.status}, message: ${response.statusText} detail: ${response.data.detail}`;
                        throw Error(errorMessage);
                    } else {
                        console.error(reson);
                        throw Error(result.detail);
                    }
                }
            }

            throw reson;
        });

        const result = response.data;

        return result;
    }

    /**
     * APIに対してGETリクエスト行います。
     * @param url URLを指定します。
     * @param params GETのパラメータを指定します。
     * @returns GETの結果を返します。
     */
    protected async httpGet<T>(url: string, params: any) {
        const response = await axios.get<T>(url, {
            params: params
        }).catch((reson) => {
            throw reson;
        });

        const result = response.data;

        return result;
    }
}

export default Service;